const baseIconSize = {
  scaledSize: new google.maps.Size(31.75, 40),
  origin: new google.maps.Point(0, 0),
  labelOrigin: new google.maps.Point(16, 16),
  anchor: new google.maps.Point(0, 40),
};

export const sameNextDayMarkers = {
  selectZoom: 13,
  clusterMaxZoom: 12,
  normalZIndex: 100,
  cediZIndex: 101,
  selectedZIndex: 200,
  normalIcon: {
    url: '/assets/images/icons/markers/marker-extra.png',
    ...baseIconSize,
  },
  selectedIcon: {
    url: '/assets/images/icons/markers/marker-extra-active.png',
    ...baseIconSize,
  },
};
export const sameNextDayConstants = {
  attempsItemList: [
    {
      value: 1,
      label: '1',
    },
    {
      value: 2,
      label: '2',
    },
    {
      value: 3,
      label: '3',
    },
    {
      value: 4,
      label: '4',
    },
    {
      value: 5,
      label: '+5',
    },
  ],
  packageTableOptionList: [
    {
      actionType: 'download',
      icon: 'fas fa-download',
    },
    {
      actionType: 'edit',
      icon: 'fas fa-edit',
    },
    {
      actionType: 'delete',
      icon: 'fas fa-trash',
    },
    {
      actionType: 'evidence',
      icon: 'fas fa-image',
    },
  ],
  mapOptions: {
    gestureHandling: 'greedy',
    styles: null,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    fullscreenControl: false,
    zoom: 3,
    width: '100%',
    height: '100%',
    center: { lat: 4.570868, lng: -74.297333 },
    commonMarkerWidth: 32,
    commonMarkerHeight: 32,
    allyMarkerWidth: 27,
    allyMarkerHeight: 34,
    extraMarkerWidth: 21,
    extraMarkerHeight: 28,
    extraPinMarkerWidth: 46,
    extraPinMarkerHeight: 46,
    startMapZoom: 6,
    notFitAndZoom: false
  },
  create: {
    defaultScheduleTime: {
      startTimeHour: 8,
      endTimeHour: 22,
    },
    zoom: 18,
    zoomCoverage: 9,
  },
  packageStatusList: [
    { label: 'common.active', value: 1 },
    { label: 'common.inactive', value: 0 },
  ],
  optionsGoogleMapsPolygon: {
    strokeOpacity: 0.5,
    strokeWeight: 1,
    fillColor: '#0AAAC0',
    fillOpacity: 0.35,
  },
  detailMenuList: [{ label: 'evidence', icon: 'fas fa-image' }],
  markerIconsStructure: {
    path: 'assets/images/icons/package-map-markers/icon-',
    extension: '.png',
    warehouseMarker: 'warehouse',
    userMarker: 'user',
    truckMarker: 'truck',
  },
};
